export enum AlertState {
  Monitoring = 'MONITORING',
  Firing = 'FIRING',
  Resolved = 'RESOLVED',
  Dismissed = 'DISMISSED',
  NeverFired = 'NEVER_FIRED',
}

export enum AlertSeverity {
  Info = 'INFO',
  Warning = 'WARNING',
  Critical = 'CRITICAL',
}
